// first, we are creating the AuthContext to hold 3 things, user, isLoading and setUser method, and second,
// creating a custom hook by using the useContext hook with AuthContext,
// so that you can directly use this custom hook to get the AuthContext data

import { createContext, useContext } from "react";

export const AuthContext = createContext({
  user: undefined,
  isLoading: false,
  setUser: () => {},
  logout: () => {},
});

export const useAuthContext = () => useContext(AuthContext);
